// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'react-datepicker';
import AddCompetitionGallery from '../addCompetitionGallery';
import FlatButton from 'material-ui/FlatButton';

class ViewCompetitionGallery extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      competition_id:props.competition_id,
      album_list:[],
      data_uploaded: false,
      data_error: false,
      addExpenseView:false,
      billView:false,
      bill_source:'',
    };
    
    this.getGalleryDetail = this.getGalleryDetail.bind(this);
    
  }

  componentDidMount() {
    this.getGalleryDetail();
    console.log(this.state);
  }

  getGalleryDetail() {
        const url = `${getLocationOrigin()}/tournament/get_competition_gallery/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'competition_id': this.state.competition_id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({album_list: data.album_list, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }
  onViewBill(bill_source){
    this.setState({billView:!this.state.billView,bill_source:bill_source})
  }


  render() {
    const okaction = <input type="button" className="button1" value="OK" onClick={() => {this.onViewBill()}} /> ;
      
    console.log(this.state)
    return(
      <div className="col-md-12">
        <AddCompetitionGallery competition_id={this.state.competition_id} />
        { this.state.album_list.length > 0 && 
            this.state.album_list.map((image,i) =>
            <div className="col-md-12" style={{marginTop:'20px'}} >
                  {image.cover_photo != null &&
                   <img id="cover_photo" src={image.cover_photo} alt="Image 1" /> 
                  }
                  {/*image.fb_album_url != null &&
                   <img id="fb_album_url" src={String(image.fb_album_url)} alt="Image 2" /> 
                  */}
            </div>
        )}
      </div>
    );
  }
}

export default ViewCompetitionGallery;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetitionGallery/index.js